import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumbs } from '@conexasaude/conexa-hero'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import type { BreadcrumbProps } from './types'

export const Breadcrumb: FunctionComponent<BreadcrumbProps> = props => {
  const { items } = props
  const { embed } = useThemeGeneratorContext()

  if (embed?.full) return null

  return (
    <Breadcrumbs.Root>
      {items.map(item => {
        const isComponent = typeof item.label === 'function'
        const Component = item.label
        const handleBreadcrumbClick = () => {
          item?.onClick?.()
        }

        return (
          <Breadcrumbs.Item
            key={item.route}
            active={item.active}
            disabled={item.disabled}
          >
            <Link onClick={handleBreadcrumbClick} to={item.route}>
              {isComponent ? <Component /> : item.label}
            </Link>
          </Breadcrumbs.Item>
        )
      })}
    </Breadcrumbs.Root>
  )
}
